const initialState = {
  configuration: null,
  userDetails: null,
};

export default initialState;
